import { BlankSlate } from "@msuite/ui/blank-slate";

/** Props Interface */
interface PreCheckBlankSlateProps {
	label: string;
}

/**
 * The one shape every state of `IntegrationPreCheck` that is not the integration itself renders
 * in: rules that could not be checked, a caller who may not read them, and an organisation with
 * no integration of this type.
 */
export function PreCheckBlankSlate({ label }: PreCheckBlankSlateProps) {
	/** Render */
	return (
		<div className="w-full h-full">
			<BlankSlate
				label={label}
				withAccessory={false}
				withBackground={false}
				withBorder={false}
			/>
		</div>
	);
}
